import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CorporateActionEventSearchCriteria extends ValueObject {
    public staticServiceProviderFileGroupingID: number | null = null;

    public corporateActionStatusID: number | null = null;

    public serviceProviderGroupingName: string | null = null;

    public status: string | null = null;

    public searchCriteria: string = "";
}